export default __webpack_public_path__ + "static/media/print.48cec254.svg";